const mediaItems = [
  {
    id: 1,
    title: '最新院线大片',
    desc: '同步上线海内外热门电影',
    tag: '每日更新',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20with%20dramatic%20golden%20lighting%20against%20dark%20theater%20background%2C%20floating%20celluloid%20film%20strips%20with%20warm%20amber%20glow%2C%20atmospheric%20movie%20premiere%20mood%2C%20elegant%20composition%20with%20deep%20shadows%20and%20soft%20highlight%20reflections%2C%20rich%20contrast%20cinematic%20photography%20style&width=800&height=500&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '热门电视剧集',
    desc: '国内外高口碑剧集一网打尽',
    tag: '热播中',
    img: 'https://readdy.ai/api/search-image?query=Modern%20elegant%20home%20theater%20setup%20with%20large%20screen%20displaying%20dramatic%20series%20scene%2C%20warm%20ambient%20lighting%20in%20dark%20room%2C%20cozy%20viewing%20atmosphere%2C%20subtle%20golden%20accent%20lights%2C%20cinematic%20mood%20with%20deep%20blacks%20and%20warm%20highlights%2C%20immersive%20entertainment%20scene&width=800&height=500&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺娱乐精选',
    desc: '热门综艺实时更新随时看',
    tag: '人气推荐',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20spotlight%20beams%20crossing%20in%20dark%20theater%20space%2C%20golden%20warm%20light%20rays%20against%20deep%20charcoal%20background%2C%20elegant%20entertainment%20show%20atmosphere%2C%20abstract%20geometric%20light%20patterns%2C%20cinematic%20color%20gradients%20of%20amber%20and%20crimson%2C%20grand%20performance%20venue%20mood&width=800&height=500&seq=media-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '经典影视回顾',
    desc: '百年影史佳作随时重温',
    tag: '经典珍藏',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20glowing%20light%20beam%20in%20dark%20room%2C%20old%20celluloid%20film%20rolls%20scattered%20artistically%2C%20nostalgic%20cinema%20atmosphere%20with%20dust%20particles%20in%20light%20beam%2C%20sepia%20and%20amber%20tones%20against%20deep%20shadows%2C%20classic%20movie%20theater%20heritage%20mood&width=800&height=500&seq=media-card-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/10 rounded-full mb-3">
            影视专区
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精彩内容速览
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            每日更新海量影视资源，电影、电视剧、综艺全覆盖
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group relative rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={`天堂影院 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] font-medium bg-primary-500 text-background-50 rounded whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}